export default function TaskDescription({

task,

editingTaskId,

editDescription,

setEditDescription,

saveDescription,

setEditingTaskId,

}) {


return (

<>

<div

onClick={() => {
 if(task.description)
  setEditingTaskId(task.id)
}}

className="
text-slate-400
mt-3
whitespace-pre-wrap
border
border-slate-800
rounded-xl
p-3
hover:border-slate-600
transition
min-h-[60px]
cursor-text
"

>


{
editingTaskId === task.id

?

<textarea

autoFocus

value={editDescription}

onChange={(e)=>
 setEditDescription(e.target.value)
}

onBlur={() =>
 saveDescription(task.id)
}

className="
w-full
bg-transparent
outline-none
text-slate-300
resize-none
"

rows={4}

/>


:

task.description || 
"Click to edit description"

}


</div>


{
editingTaskId === task.id &&

<div className="flex gap-2 mt-2">


<button

onClick={() =>
 saveDescription(task.id)
}

className="
px-3
py-1
bg-green-700
rounded-lg
text-sm
"

>
Save
</button>


<button

onClick={() =>
 setEditingTaskId(null)
}

className="
px-3
py-1
bg-slate-700
rounded-lg
text-sm
"

>
Cancel
</button>


</div>

}


</>

)

}